// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   PrivacyConsentModal — 기존 회원 약관/수신동의 수집
   OnboardingModal 의 shell(overlay/card/header/foot) 재사용, 동의 리스트만 전용.
   ======================================================================== */

.privacy-consent {
  max-width: 480px;
}

.privacy-consent__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.privacy-consent__row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 4px;
}

.privacy-consent__row--all {
  border-bottom: 1px solid var(--fg-line, #e5e7eb);
  padding-bottom: 16px;
  margin-bottom: 4px;
}

.privacy-consent__row--two-line {
  align-items: flex-start;
}

.privacy-consent__check {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: none;
  background: var(--fg-line, #d1d5db);
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: background 160ms ease;
  padding: 0;
}

.privacy-consent__row--two-line .privacy-consent__check {
  margin-top: 2px;
}

.privacy-consent__check--active {
  background: var(--fg-button, #7c3aed);
}

.privacy-consent__tag {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-gray, #6b7280);
}

.privacy-consent__tag--required {
  color: var(--fg-button, #7c3aed);
}

.privacy-consent__text {
  font-size: 14px;
  color: var(--fg-text-basic, #111827);
}

.privacy-consent__text--all {
  font-size: 15px;
  font-weight: 700;
}

.privacy-consent__text-group {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
  min-width: 0;
}

.privacy-consent__text-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.privacy-consent__subtext {
  font-size: 12px;
  line-height: 1.5;
  color: var(--fg-text-gray, #6b7280);
}

.privacy-consent__view {
  margin-left: auto;
  flex-shrink: 0;
  font-size: 12px;
  color: var(--fg-text-gray, #6b7280);
  text-decoration: underline;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 2px;
}

.privacy-consent__view:hover {
  color: var(--fg-text-basic, #111827);
}

/* ─── 푸터 / 제출 버튼 ─── */
.privacy-consent__foot {
  display: block;
  padding: 16px 28px 24px;
}

.privacy-consent__submit {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 12px;
  background: var(--fg-button, #7c3aed);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 160ms ease, opacity 160ms ease;
}

.privacy-consent__submit:hover:not(:disabled) {
  background: var(--fg-button-hover, #6d28d9);
}

.privacy-consent__submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/css/PrivacyConsent.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;EAChD,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* ========================================================================\n   PrivacyConsentModal — 기존 회원 약관/수신동의 수집\n   OnboardingModal 의 shell(overlay/card/header/foot) 재사용, 동의 리스트만 전용.\n   ======================================================================== */\n\n.privacy-consent {\n  max-width: 480px;\n}\n\n.privacy-consent__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.privacy-consent__row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 4px;\n}\n\n.privacy-consent__row--all {\n  border-bottom: 1px solid var(--fg-line, #e5e7eb);\n  padding-bottom: 16px;\n  margin-bottom: 4px;\n}\n\n.privacy-consent__row--two-line {\n  align-items: flex-start;\n}\n\n.privacy-consent__check {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  border: none;\n  background: var(--fg-line, #d1d5db);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: background 160ms ease;\n  padding: 0;\n}\n\n.privacy-consent__row--two-line .privacy-consent__check {\n  margin-top: 2px;\n}\n\n.privacy-consent__check--active {\n  background: var(--fg-button, #7c3aed);\n}\n\n.privacy-consent__tag {\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-gray, #6b7280);\n}\n\n.privacy-consent__tag--required {\n  color: var(--fg-button, #7c3aed);\n}\n\n.privacy-consent__text {\n  font-size: 14px;\n  color: var(--fg-text-basic, #111827);\n}\n\n.privacy-consent__text--all {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.privacy-consent__text-group {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex: 1;\n  min-width: 0;\n}\n\n.privacy-consent__text-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.privacy-consent__subtext {\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--fg-text-gray, #6b7280);\n}\n\n.privacy-consent__view {\n  margin-left: auto;\n  flex-shrink: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray, #6b7280);\n  text-decoration: underline;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0 2px;\n}\n\n.privacy-consent__view:hover {\n  color: var(--fg-text-basic, #111827);\n}\n\n/* ─── 푸터 / 제출 버튼 ─── */\n.privacy-consent__foot {\n  display: block;\n  padding: 16px 28px 24px;\n}\n\n.privacy-consent__submit {\n  width: 100%;\n  padding: 14px;\n  border: none;\n  border-radius: 12px;\n  background: var(--fg-button, #7c3aed);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 160ms ease, opacity 160ms ease;\n}\n\n.privacy-consent__submit:hover:not(:disabled) {\n  background: var(--fg-button-hover, #6d28d9);\n}\n\n.privacy-consent__submit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
